var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "slide-y-up-transition",
    [
      _c("v-select", {
        attrs: {
          multiple: "",
          placeholder: _vm.placeholder,
          options: _vm.localOptions,
          filtered: _vm.filtered,
          searchable: _vm.searchable,
          label: _vm.label,
          value: _vm.valueProp,
          closeOnSelect: _vm.closeOnSelect,
          loading: _vm.isLoading,
          disabled: _vm.disabled,
          reduce: _vm.reduce
        },
        scopedSlots: _vm._u([
          {
            key: "open-indicator",
            fn: function(ref) {
              var attributes = ref.attributes
              return [
                _c("span", _vm._b({}, "span", attributes, false), [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "12",
                        height: "6",
                        viewBox: "0 0 12 6"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "Path_4_Copy",
                          "data-name": "Path 4 Copy",
                          d: "M0,0,6,6,0,12Z",
                          transform: "translate(12) rotate(90)",
                          fill: "#8a8a8a"
                        }
                      })
                    ]
                  )
                ])
              ]
            }
          },
          {
            key: "no-options",
            fn: function() {
              return [
                _vm._v(
                  "\r\n      " +
                    _vm._s(_vm.$t("base-select.noOptions")) +
                    "\r\n    "
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.localValue,
          callback: function($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6add7f54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6add7f54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/BaseMultiSelect.vue
// module id = 2622
// module chunks = 1 3 4 37 142 143